const collator = new Intl.Collator("ko-KR", { numeric: true, sensitivity: "base" });
const text = (value) => String(value ?? "").trim();

export const getCauseMachineName = (asset = {}) =>
  text(asset.safe_machine_name) || text(asset.machine_name) || "설비명 미등록";

const assetSearchText = (asset) => [
  asset.safe_machine_name, asset.machine_name, asset.process_name, asset.process_description,
].map(text).join(" ").toLocaleLowerCase();

// Filter before calculating spans so searching never leaves empty merged cells.
export function buildCauseGroups(data = [], query = "", sorting = {}) {
  const terms = text(query).toLocaleLowerCase().split(/\s+/).filter(Boolean);
  const matches = (value) => terms.every((term) => value.includes(term));
  const key = sorting.key || "machine";
  const direction = sorting.direction === "desc" ? -1 : 1;
  const compare = (a, b) => direction * collator.compare(text(a), text(b));
  const machines = new Map();

  (Array.isArray(data) ? data : []).forEach((item, index) => {
    if (!item?.registerAssetData) return;
    const asset = item.registerAssetData;
    const source = Array.isArray(item.situationData) ? item.situationData.filter(Boolean) : [];
    const assetText = assetSearchText(asset);
    const situations = source.filter((situation) => matches([
      assetText, situation.danger_category, situation.danger_cause, situation.danger_description,
    ].map(text).join(" ").toLocaleLowerCase()));
    if (source.length ? !situations.length : !matches(assetText)) return;

    if (key.startsWith("danger_")) situations.sort((a, b) => compare(a[key], b[key]));
    const assetKey = String(asset.register_asset_id ?? item.id ?? index);
    // Names are not identifiers: equally named equipment must remain separate.
    const machineKey = asset.machine_id == null ? `asset:${assetKey}` : `machine:${asset.machine_id}`;
    if (!machines.has(machineKey)) {
      machines.set(machineKey, { key: machineKey, asset, assets: [], rowSpan: 0 });
    }
    const group = machines.get(machineKey);
    const rowSpan = Math.max(1, situations.length);
    group.assets.push({ ...item, key: assetKey, situationData: situations, rowSpan });
    group.rowSpan += rowSpan;
  });

  const assetValue = (item) => key.startsWith("danger_")
    ? item.situationData[0]?.[key]
    : item.registerAssetData.process_name;
  const groups = Array.from(machines.values());
  groups.forEach((group) => group.assets.sort((a, b) =>
    compare(assetValue(a), assetValue(b)) || collator.compare(a.key, b.key)));
  return groups.sort((a, b) => {
    const value = (group) => key === "machine"
      ? getCauseMachineName(group.asset) : assetValue(group.assets[0]);
    return compare(value(a), value(b)) || collator.compare(getCauseMachineName(a.asset), getCauseMachineName(b.asset));
  });
}
